// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cfb289b7","283":"3dbebeff","284":"ee538a66","622":"3ef9a94c","644":"2ced77de"}[chunkId] + ".chunk.js";
};